/* Scroll-snap carousel with prev/next buttons (shared).
   Markup: [data-attack-carousel] containing .attackletics-com-card-container (scroller)
   and .attackletics-com-slider-button-left / -right. Behaviour copied from the Hitting Mat section. */
(function () {
  function init(root) {
    if (root.dataset.attackCarouselReady) return;
    var container = root.querySelector('.attackletics-com-card-container');
    if (!container) return;
    root.dataset.attackCarouselReady = '1';
    var prev = root.querySelector('.attackletics-com-slider-button-left');
    var next = root.querySelector('.attackletics-com-slider-button-right');
    var current = 0;
    function total() { return Math.round(container.scrollWidth / container.clientWidth); }
    function go(i, behavior) {
      var t = total();
      if (t <= 1) return;
      current = (i + t) % t;
      container.scrollTo({ left: current * container.clientWidth, behavior: behavior || 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    window.addEventListener('resize', function () { go(current, 'auto'); });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-attack-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
